import { Validators } from '@angular/forms';
import {
  CancerHistoryStatus,
  PregnancyType,
  ValidationPair,
} from '@app/modules/service-data/types/service-data.types';
import { gestationAgeValidValidator } from '@app/modules/service-data/validators/gestation-age-valid.validator';
import { crossFieldValidator } from '@shared/validators/cross-field-validator';
import { errorValueValidator } from '@shared/validators/error-value-validator';

export const rhValidationSet: ValidationPair = {
  children: {
    rhd: {
      children: {
        patientHistory: {
          children: {
            rhdStatus: {
              children: {
                status: {
                  validators: [Validators.required, errorValueValidator(false)],
                },
              },
            },
          },
        },
      },
    },
    shared: {
      children: {
        doctorInformation: {
          children: {
            doctorId: {
              validators: [Validators.required],
            },
          },
        },
        patientInformation: {
          children: {
            height: {
              validators: [Validators.min(0)],
            },
            weight: {
              validators: [Validators.min(0)],
            },
          },
        },
        patientHistory: {
          children: {
            cancerHistory: {
              children: {
                hasHistory: {
                  validators: [Validators.required],
                },
                status: {
                  validators: [
                    errorValueValidator(CancerHistoryStatus.CurrentlyAffected),
                  ],
                },
              },
            },
            albuminTherapy: {
              children: {
                hasReceived: {
                  validators: [Validators.required],
                },
                isRelevant: {
                  validators: [errorValueValidator(true)],
                },
              },
            },
            cellularImmunotherapy: {
              children: {
                hasReceived: {
                  validators: [Validators.required],
                },
                isRelevant: {
                  validators: [errorValueValidator(true)],
                },
              },
            },
            stemCellTherapy: {
              children: {
                hasReceived: {
                  validators: [Validators.required, errorValueValidator(true)],
                },
              },
            },
            transplantSurgery: {
              children: {
                hasReceived: {
                  validators: [Validators.required, errorValueValidator(true)],
                },
              },
            },
            bloodTransfusion: {
              children: {
                hasReceived: {
                  validators: [Validators.required],
                },
                isRelevant: {
                  validators: [errorValueValidator(true)],
                },
              },
            },
          },
        },
        currentPregnancyInformation: {
          children: {
            expectedConfinementDate: {
              validators: [Validators.required],
            },
            gestationAge: {
              children: {
                week: {
                  validators: [
                    Validators.required,
                    Validators.min(10),
                    Validators.max(40),
                  ],
                },
                day: {
                  validators: [
                    Validators.required,
                    Validators.min(0),
                    Validators.max(6),
                  ],
                },
              },
            },
            isGestationAgeAutomaticallyCalculated: {
              validators: [Validators.required],
            },
            pregnancyType: {
              validators: [Validators.required],
            },
          },
        },
      },
      validators: [
        gestationAgeValidValidator(),
        crossFieldValidator(
          'patientHistory.cancerHistory.status',
          'patientHistory.cancerHistory.hasHistory',
          true
        ),
        crossFieldValidator(
          'patientHistory.albuminTherapy.isRelevant',
          'patientHistory.albuminTherapy.hasReceived',
          true
        ),
        crossFieldValidator(
          'patientHistory.cellularImmunotherapy.isRelevant',
          'patientHistory.cellularImmunotherapy.hasReceived',
          true
        ),
        crossFieldValidator(
          'patientHistory.bloodTransfusion.isRelevant',
          'patientHistory.bloodTransfusion.hasReceived',
          true
        ),
        crossFieldValidator(
          'currentPregnancyInformation.chorionicityType',
          'currentPregnancyInformation.pregnancyType',
          PregnancyType.twins
        ),
      ],
    },
  },
};
